import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { connect } from "react-redux";
import { loadRecord } from "MODULES/shared/decorators";
import {
  ClipboardCopy,
  RecordPager,
  StatusTags
} from "MODULES/shared/components";
import { shortDate } from "LIB/formatters/date";
import * as actions from "MODULES/RMAsAndWarranties/actions";
import {
  CANCELLED,
  CREDIT_REQUESTED,
  CODE,
  CREATED_AT,
  TYPE,
  WARRANTY_CONSIDERATION
} from "APP_ROOT/constants";
import CustomerRmaActions from "MODULES/CustomerRmas/components/Detail/Actions/Actions";
import Panel from "./Panel";
import Body from "./Body";
import Actions from "./Actions";

export function Detail({ rma }) {
  return (
    <div>
      <div className="page-header page-header-bar">
        <h1>
          <RecordPager baseUrl="/rmas" record={rma} />
          &nbsp;
          <span className="header-content">{rma.get(CODE)}</span>
          &nbsp;
          <ClipboardCopy name={rma.get(CODE)} type="RMA" />
          <span className="small text-muted">
            Created {shortDate(rma.get(CREATED_AT))}
          </span>
          {rma.get(TYPE) === "VendorRma" && <Actions />}
          {rma.get(TYPE) === "CustomerRma" && <CustomerRmaActions />}
          <Warnings rma={rma} />
        </h1>
      </div>
      <div className="row">
        <Panel rma={rma.toJS()} />
        <Body rma={rma.toJS()} />
      </div>
    </div>
  );
}

function Warnings({ rma }) {
  return (
    <StatusTags>
      <div>
        {rma.get(CANCELLED) && (
          <span className="label label-danger">
            <i className="fa fa-ban" />
            &nbsp;&nbsp;Cancelled
          </span>
        )}
        {rma.get(CREDIT_REQUESTED) && (
          <span className="label label-danger">
            <i className="fa fa-check" />
            &nbsp;&nbsp;Credit Requested
          </span>
        )}
        {rma.get(WARRANTY_CONSIDERATION) && (
          <span className="label label-success">
            <i className="fa fa-check" />
            &nbsp;&nbsp;Warranty Requested
          </span>
        )}
      </div>
    </StatusTags>
  );
}

Warnings.propTypes = {
  rma: T.instanceOf(Map).isRequired
};

Detail.propTypes = {
  rma: T.instanceOf(Map).isRequired
};

export default connect(state => ({
  rma: state.rmaDetail.get("rma")
}))(
  loadRecord({
    reducer: "rmaDetail",
    name: "rma",
    action: actions.fetch
  })(Detail)
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Detail.jsx